import React from "react";
import FooterPagesBackground from "../assets/FooterPagesBackground.webp";
import liggandebakrund from "../assets/liggandebakgrund.svg";
import ToHomeBtn from "../components/Shared/ToHomepageBtn";
import "./css/NewsPage.css";
import FooterInsideSmallerPages from "./FooterInsideSmallerPages";

function NewsPage() {
  // Sample news data - in a real application, this would come from an API or database
  const newsItems = [
    {
      id: 1,
      title: "Ny produktlansering",
      date: "2023-05-15",
      image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?fm=jpg&q=80&w=1000",
      content: "Vi är glada att kunna presentera vår nya produktlinje som kommer att revolutionera marknaden.",
      category: "Produktnyheter"
    },
    {
      id: 2,
      title: "Utökad leveransservice",
      date: "2023-05-10",
      image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?fm=jpg&q=80&w=1000",
      content: "Vi har nu utökat vår leveransservice till fler områden i Sverige för att nå fler kunder.",
      category: "Tjänster"
    },
    {
      id: 3,
      title: "Nytt partnerskap",
      date: "2023-05-05",
      image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?fm=jpg&q=80&w=1000",
      content: "Vi har ingått ett nytt strategiskt partnerskap för att förbättra våra tjänster ytterligare.",
      category: "Företagsnyheter"
    },
    {
      id: 4,
      title: "Hållbarhetsinitiativ",
      date: "2023-05-01",
      image: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?fm=jpg&q=80&w=1000",
      content: "Vi lanserar ett nytt hållbarhetsinitiativ för att minska vår miljöpåverkan.",
      category: "Hållbarhet"
    }
  ];

  return (
    <div className="news-page-container">
      <div
        className="news-background-image"
        style={{ backgroundImage: `url(${liggandebakrund})` }}
      ></div>
      <div className="news-content-container">
        <ToHomeBtn />
        <h1 className="news-page-title">Nyheter / Blogg</h1>
        
        <div className="news-columns-container">
          {/* Column 1: Images */}
          <div className="news-column news-images-column">
            <h2>Bilder</h2>
            <div className="news-images-container">
              <div className="news-images-wrapper">
                {newsItems.map((item) => (
                  <div key={item.id} className="news-image-item">
                    <img src={item.image} alt={item.title} />
                    <p className="news-image-caption">{item.title}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          {/* Column 2: Latest News */}
          <div className="news-column">
            <h2>Senaste nytt</h2>
            <div className="news-list">
              <div className="news-list-wrapper">
                {newsItems.map((item) => (
                  <div key={item.id} className="news-item">
                    <h3>{item.title}</h3>
                    <p className="news-date">{item.date}</p>
                    <p className="news-excerpt">{item.content.substring(0, 100)}...</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          {/* Column 3: Categories */}
          <div className="news-column">
            <h2>Kategorier</h2>
            <div className="news-categories">
              <ul>
                <li>Produktnyheter</li>
                <li>Tjänster</li>
                <li>Företagsnyheter</li>
                <li>Hållbarhet</li>
                <li>Evenemang</li>
                <li>Kundberättelser</li>
              </ul>
            </div>
          </div>
          
          {/* Column 4: Newsletter Signup */}
          <div className="news-column">
            <h2>Nyhetsbrev</h2>
            <div className="news-newsletter">
              <p>Prenumerera på vårt nyhetsbrev för att få de senaste nyheterna direkt i din inkorg.</p>
              <form className="news-newsletter-form">
                <input type="email" placeholder="Din e-postadress" />
                <button type="submit">Prenumerera</button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <FooterInsideSmallerPages />
    </div>
  );
}

export default NewsPage; 